import { useState, useRef, useEffect } from "react";
import { Coffee, X } from "lucide-react";

const KOFI_URL = "https://ko-fi.com/barrelcastsurf";

export default function SupportButton() {
  const [open, setOpen] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handleClick = (e: MouseEvent) => {
      if (cardRef.current && !cardRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  return (
    // bottom-24 clears a ~64-72px bottom nav bar + safe-area inset.
    // If it overlaps or floats too high above your nav, adjust this one value.
    <div className="fixed bottom-24 right-4 z-40" ref={cardRef}>
      {open && (
        <div className="absolute bottom-16 right-0 w-64 rounded-2xl border border-primary/20 bg-card shadow-xl p-4 animate-in fade-in slide-in-from-bottom-2 duration-150">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div className="flex items-center gap-1.5">
              <Coffee className="h-4 w-4 text-primary" />
              <h4 className="font-display text-sm font-bold">Support Barrelcast</h4>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-muted-foreground hover:text-foreground shrink-0"
              aria-label="Close"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
          <p className="text-xs text-muted-foreground mb-3">
            Built by one person, fuelled by coffee and salt water. Keeps the buoys online.
          </p>
          <div className="flex flex-col gap-2">
            <a
              href={KOFI_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-gradient-sunset text-accent-foreground font-bold text-xs uppercase tracking-widest px-4 py-2.5 rounded-xl hover:opacity-90 transition-opacity"
            >
              <Coffee className="h-3.5 w-3.5" /> Buy me a coffee
            </a>
            <a
              href={KOFI_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 border border-primary/30 text-primary font-bold text-xs uppercase tracking-widest px-4 py-2.5 rounded-xl hover:bg-primary/10 transition-colors"
            >
              ☕ × 1 — Buy a round
            </a>
          </div>
          <p className="text-[10px] text-muted-foreground mt-2 text-center">
            Opens Ko-fi · No account needed
          </p>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Support Barrelcast"
        className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-sunset text-accent-foreground shadow-lg hover:opacity-90 transition-opacity"
      >
        {open ? <X className="h-5 w-5" /> : <Coffee className="h-5 w-5" />}
      </button>
    </div>
  );
}
